import { GetStaticPropsContext, GetStaticPropsResult } from 'next';

import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { revalidateTimeout } from '@/lib/constants';
import { Node, NodeProps } from '@/components/node';
import { drupal } from '@/utils/drupal/drupal';
import { getGlobalElements } from '@/utils/drupal/get-global-elements';
import { getParams } from '@/utils/drupal/get-params';
import { DrupalNode, DrupalParagraph } from 'next-drupal';
import type { NodePageProps } from 'pages/[...slug]';
import Layout from '@/components/layouts/Layout';
import { BridlePage } from '@/components/bridle-page';
import { getResourcePath } from '@/utils/drupal/get-resource-path';

const Trazabilidad = ({
  content,
  blocks,
  theme,
  preFooter,
  meta,
  canonical,
  ...props
}: NodePageProps) => {
  const router = useRouter();
  const [dataBridle, setDataBridle] = useState(undefined);
  const { bridle } = router.query;
  const [popUp, setPopUp] = useState(false);
  const [activoValoracion, setActivoValoracion] = useState(true);
  const [valorado, setValorado] = useState(false);

  useEffect(() => {
    if (bridle) {
      const fetchData = async () => {
        const data = await fetch(`/api/trazability?bridle=${bridle}`);
        const json = await data.json();
        setDataBridle(json);
      };

      setActivoValoracion(
        localStorage.getItem('Valoration')
          ? !localStorage.getItem('Valoration')?.split('-').includes(bridle)
          : true
      );

      fetchData();
    }
  }, [bridle]);

  useEffect(() => {
    if (valorado && bridle) {
      const temp = localStorage.getItem('Valoration')
        ? localStorage.getItem('Valoration')?.split('-')
        : [];

      bridle && temp.push(bridle);

      setActivoValoracion(false);
      localStorage.setItem('Valoration', temp.join('-'));
    }
  }, [valorado, bridle]);

  const tabsHeaders = ['Tipo de Pieza', 'Orígen', 'Curación', 'Consejos'];

  if (bridle) {
    return (
      <BridlePage
        blocks={blocks} theme={theme} preFooter={preFooter} meta={meta} dataBridle={dataBridle} bridle={bridle}
        tabsHeaders={tabsHeaders}
        setPopUp={setPopUp}
        activoValoracion={activoValoracion}
        setValorado={setValorado}
        popUp={popUp}
        products={content.views.products}
        canonical={canonical}
      />

    );
  } else {
    return (
      !bridle && (
        <Layout blocks={blocks} theme={theme ? 'dark' : 'light'} layoutType='base' preFooter={preFooter} meta={meta} canonical={canonical}>
          <Node content={content}  {...props} />
        </Layout>
      )
    );
  }
};

export default Trazabilidad;

export async function getStaticProps(
  context: GetStaticPropsContext
): Promise<GetStaticPropsResult<NodePageProps>> {
  const path = await drupal.translatePath("/es/trazabilidad-jamon");
  const resource = await getResourcePath(path, context);
  if (resource == null) {
    return {
      notFound: true,
      revalidate: revalidateTimeout
    };

  }
  const type = path.jsonapi?.resourceName;
  const contentObject = { content: { views: {} } } as NodeProps;
  contentObject.content.node = resource;
  const p = resource.field_content.map(async (paragraph: DrupalParagraph) => (
    await drupal.getResource<DrupalParagraph>(
      paragraph.type, paragraph.id, {
      params: getParams(paragraph.type)
        .getQueryObject(),
    }
    )
  ));
  contentObject.content.paragraphs = await Promise.all(p);
  contentObject.content.views.products = await drupal.getResourceCollectionFromContext<DrupalNode[]>(
    "shopify_product--shopify_product", context, {
    params: getParams("shopify_product--shopify_product", "card")
      .getQueryObject(),
  });

  contentObject.content.type = type;

  const slug = "/es/trazabilidad-jamon"

  return {
    props: {
      ...(await getGlobalElements(context)),
      content: contentObject.content,
      theme: contentObject.content.node.field_dark_banner,
      preFooter: contentObject.content.node.field_show_prefooter,
      meta: contentObject.content.node.metatag ? contentObject.content.node.metatag : null,
      canonical: path.entity.path ? path.entity.path : slug
    },
    revalidate: revalidateTimeout
  };
}
